(function () {
  const slides = document.querySelectorAll(".promo-slide");
  let count = 0;
  const prev = document
    .querySelector(".promo-banner-prev-btn")
    ?.addEventListener("click", goPrevious);
  const next = document
    .querySelector(".promo-banner-next-btn")
    ?.addEventListener("click", goNext);
  function goPrevious() {
    count--;
    if (count < 0) {
      count = slides.length - 1;
    }
    slideContent();
  }

  function goNext() {
    count++;
    if (count >= slides.length) {
      count = 0;
    }
    slideContent();
  }

  function slideContent() {
    slides.forEach((slide, index) => {
      slide.style.transform = `translateX(-${100 * count}%)`;
    });
  }
})();
